/** Used for "search inside note content" (replaces faEnvelopeOpenText) */
export function ImgContentSearch({ size = 16 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg">
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <path d="M3 9l9 5 9-5" />
      <path d="M9 15h3" />
      <path d="M9 18h2" />
    </svg>
  );
}
